/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from "@angular/core";
import { AlertController, Platform, ToastController } from '@ionic/angular';
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "@shared/services/user.service";
import { ConnectionStateService } from "@shared/services/connection-state.service";
import { Capacitor } from "@capacitor/core";
import { InAppReview } from '@capacitor-community/in-app-review';
import { webVersion } from 'src/environments/environment';
import { Preferences } from "@capacitor/preferences";
import { NativeSettings } from "capacitor-native-settings";
import {AppLauncher} from '@capacitor/app-launcher';
import { LanguageEnum } from "@shared/enums/LanguageEnum";
import { App } from "@capacitor/app";
@Injectable({
  providedIn: 'root'
})
export class UtilService {
    public static loggedOut: boolean = false;
    public appName: string = '';
    public versionNumber: string = '';

    private static serverUnreacheableMsg: string = 'unableToConnectMsg';
    private static serverUnreacheableMsgTime: number = 4000;
    private isAndroid: boolean;
    private openInAppReview:boolean = false;
    private callInAppReview:boolean = false;
    private lastConnectionToastTime: number = 0;
    private connectionToastVisible: boolean = false;
    constructor(
        private toastCtrl: ToastController,
        private platform: Platform,
        private translate: TranslateService,
        private alertCtrl: AlertController,
        private connectionStateService: ConnectionStateService,
    ){
      this.isAndroid = this.platform.is('android');

      App.addListener('pause', () => {
        if(this.callInAppReview){
          this.openInAppReview = true;
        }

      });

      this.collectVersionInfo();
    }


    public collectVersionInfo(){
      if (Capacitor.isNativePlatform()) {
        App.getInfo().then((val) => {
          if(val != null){
            console.log('this.appVersion.getAppName(): ' + val.name);
            this.appName = val.name;
            console.log('this.appVersion.getVersionNumber(): ' + val);
            this.versionNumber = val.version;
          } 
        })
      } else {
        this.versionNumber = webVersion
      }
    }


    public isNative(): boolean {
        //alert(document.URL);
        return Capacitor.isNativePlatform();
    }

    /**
     * ObjectId da i-ésima foto exibida de um soul (picture0..picture8 na ordem em que
     * aparecem, ignorando slots vazios). Usado no Elogio (Compliment) para mandar o
     * pictureId ao backend. Retorna null se não houver foto nesse índice.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getPictureOid(soul: any, displayIndex: number): string | null {
        if (soul == null || displayIndex == null || displayIndex < 0) {
            return null;
        }
        let count = 0;
        for (let n = 0; n < 9; n++) {
            const pic = soul['picture' + n];
            if (pic != null && pic.$oid != null) {
                if (count === displayIndex) {
                    return pic.$oid;
                }
                count++;
            }
        }
        return null;
    }

    /** Primary language subtag, lowercased (pt-BR → pt). Empty if missing. */
    public static languageBaseCode(language: string | null | undefined): string {
      if (!language) {
        return '';
      }
      return String(language).trim().toLowerCase().replace(/_/g, '-').split('-')[0];
    }

    /** Maps any language code to a supported LanguageEnum value (fallback EN). */
    public static normalizeLanguage(language: string | null | undefined): LanguageEnum {
      const base = UtilService.languageBaseCode(language);
      if (!base) {
        return LanguageEnum.EN;
      }
      const supported = Object.values(LanguageEnum) as string[];
      return (supported.includes(base) ? base : LanguageEnum.EN) as LanguageEnum;
    }

    /**
     * Chooses UI language from saved USER_DATA vs browser.
     * Extracted so specs do not depend on Capacitor Preferences spies.
     */
    public static resolveTranslateLanguage(
      userData: { language?: string | null; setLanguageManually?: boolean } | null | undefined,
      browserLanguage: string | null | undefined,
    ): LanguageEnum {
      if (
        userData != null &&
        userData.language != null &&
        (userData.setLanguageManually || userData.language != 'en')
      ) {
        const normalized = UtilService.normalizeLanguage(userData.language);
        // Unsupported legacy codes (e.g. nl) without a manual choice: prefer browser.
        if (
          !userData.setLanguageManually &&
          normalized === LanguageEnum.EN &&
          UtilService.languageBaseCode(userData.language) !== 'en'
        ) {
          return UtilService.normalizeLanguage(browserLanguage);
        }
        return normalized;
      }
      return UtilService.normalizeLanguage(browserLanguage);
    }

    /** Isolated for unit tests — Capacitor Preferences spies are unreliable on the plugin proxy. */
    protected async readStoredUserData(): Promise<any> {
      const stored = await Preferences.get({ key: 'USER_DATA' });
      return stored.value ? JSON.parse(stored.value) : null;
    }

    public async initTranslate() {
      this.translate.setDefaultLang('en');

      const val = await this.readStoredUserData();
      const language = UtilService.resolveTranslateLanguage(val, this.translate.getBrowserLang());
      console.log('initTranslate language: ' + language);
      this.translate.use(language);
    }


    async presentToast(toastCtrl: ToastController,msg: string, dur: number) {

      const toast = await toastCtrl.create({
        message: msg,
        duration: dur,
        buttons: [
          {
            text: this.translate.instant('close'),
            role: 'cancel',
          }
        ],
  
      });
      toast.present();
    }

    public showToastUnableToConnect(toastCtrl: ToastController) {
      // Só exibe se realmente deve mostrar erro de conexão
      try {
        if (this.connectionStateService.shouldShowConnectionError()) {
          this.presentToast(toastCtrl, this.translate.instant(UtilService.serverUnreacheableMsg), UtilService.serverUnreacheableMsgTime)
        }
      } catch (error) {
        console.error('Error in showToastUnableToConnect:', error);
        // Fallback para exibir toast sem verificação de estado
        this.presentToast(toastCtrl, this.translate.instant(UtilService.serverUnreacheableMsg), UtilService.serverUnreacheableMsgTime)
      }
    }

    public showTopToastUnableToConnect(toastCtrl: ToastController) {
      // Só exibe se realmente deve mostrar erro de conexão
      try {
        if (this.connectionStateService.shouldShowConnectionError()) {
          this.presentTopToast(toastCtrl, this.translate.instant(UserService.serverUnreacheableMsg), UserService.serverUnreacheableMsgTime)
        }
      } catch (error) {
        console.error('Error in showTopToastUnableToConnect:', error);
        // Fallback para exibir toast sem verificação de estado
        this.presentTopToast(toastCtrl, this.translate.instant(UserService.serverUnreacheableMsg), UserService.serverUnreacheableMsgTime)
      }
    }

    public async presentTopToast(toastCtrl: ToastController, msg: string, dur: number) {
      const now = Date.now();
      // Só exibe se já passou 30 segundos desde o último toast (reduzido de 1 minuto)
      if (this.connectionToastVisible || (now - this.lastConnectionToastTime < 30000)) return;
      this.connectionToastVisible = true;
      this.lastConnectionToastTime = now;
      const toast = await toastCtrl.create({
        message: msg,
        position: 'top',
        duration: dur,
        buttons: [
          {
            text: this.translate.instant('close'),
            role: 'cancel',
          }
        ],
      });
      toast.onDidDismiss().then(() => {
        this.connectionToastVisible = false;
      });
      toast.present();
    }

    public async presentTopToastGreen(toastCtrl: ToastController, msg: string, dur: number) {
      const toast = toastCtrl.create({
        message: msg,
        cssClass: 'sucessToastText',
        position: 'top',
        duration: dur,
        buttons: [
          {
            text: this.translate.instant('close'),
            role: 'cancel',
          }
        ],
  
      });
      (await toast).present();
    }

    public async showAlertRateNow(){

      console.log('showAlertRateNow');
      const alert = this.alertCtrl.create({
        header: this.translate.instant('enjoyingSoFar'),
        buttons: [
          {
            text: this.translate.instant('notReally'),
            role: 'cancel',
          },
          {
            text: this.translate.instant('yes'),
            role:'confirm',
            handler: async () => {

              this.callInAppReview = true;
              await InAppReview.requestReview();

              setTimeout(async () => {
                if(!this.openInAppReview){
                  
                  this.showAlertWouldYouRateUs();
                  
                }
              }, 1000);

              setTimeout(async () => {
                this.callInAppReview = false;
                this.openInAppReview = false;
              }, 5000);



              // if (this.isAndroid) {
              //   this.showAlertWouldYouRateUs();
              // } else{
              //   RateApp.requestReview();
              // }

            }
          }
        ]
      });
  
      (await alert).present();
    }

    public async showAlertRateNowChat(){
      console.log('showAlertRateNow');
      const alert = this.alertCtrl.create({
        header: this.translate.instant('enjoyingSoFar'),
        buttons: [
          {
            text: this.translate.instant('notReally'),
            role: 'cancel',
          },
          {
            text: this.translate.instant('yes'),
            role:'confirm',
            handler: async () => {
              this.showAlertWouldYouRateUs();
            }
          }
        ]
      });
  
      (await alert).present();
    }


    public async showAlertWouldYouRateUs(onDismiss?: () => void){
      const alert = this.alertCtrl.create({
        header: this.translate.instant('wouldYouRateUs'),
        subHeader: this.translate.instant('goodReviewHelps'),
        buttons: [
          {
            text: this.translate.instant('noThanks'),
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
              onDismiss?.();
            },
          },
          {
            text: this.translate.instant('rateNow'),
            handler: async () => {
              console.log(this.appName);

              if (this.appName === 'Flamr') {
                if (this.isAndroid) {
                  await AppLauncher.openUrl({url: 'https://play.google.com/store/apps/details?id=com.leftyapp'});
                } else {
                  await AppLauncher.openUrl({url: 'https://apps.apple.com/br/app/lefty-namoro-da-esquerda/id1619368686'});
                }
              } else if (this.appName === 'Fyra') {
                if (this.isAndroid) {
                  await AppLauncher.openUrl({url: 'https://play.google.com/store/apps/details?id=com.leftyapp'});
                } else {
                  await AppLauncher.openUrl({url: 'https://apps.apple.com/app/id1619368686'});
                }
              } else {
                if (this.isAndroid) {
                  await AppLauncher.openUrl({url: 'https://play.google.com/store/apps/details?id=com.veggly'});
                } else {
                  await AppLauncher.openUrl({url: 'https://apps.apple.com/br/app/veggly-namoro-vegano/id1418079413'});
                }
              }
              onDismiss?.();
            },
          },
        ],
      });
      (await alert).present();
    }

    

    async showModalAlert(message: any) {
      const alert = this.alertCtrl.create({
        //title: this.translate.instant('statisticalOnly'),
        subHeader: message,
        buttons: [
          // {
          //   text: this.translate.instant('cancel'),
          //   handler: () => {
          //     console.log('cancel clicked');
          //     return;
  
          //   }
          // },
          {
            text: 'OK',
            handler: () => { }
          }
        ]
      });
  
      (await alert).present();
    }
  

    async showModalAlertRequestPermission(message: any, Androidcommand:any, IOScommand:any) {
      const alert = this.alertCtrl.create({
        subHeader: message,
        buttons: [
          {
            text: this.translate.instant('notNow'),
            role: 'cancel',
          },
          {
            text: this.translate.instant('toAllow'),
            handler: () => { 
              NativeSettings.open({
                optionAndroid: Androidcommand, 
                optionIOS: IOScommand
              })
            }
          }
        ]
      });

      (await alert).present();
    }
  

    

    /**
     * Um Elogio (compliment; `recadinho` é o nome legado) na PRÉVIA da lista
     * de conversas.
     *
     * Espelha a detecção de `chat.page.ts` (`isComplimentFlag` + pictureId +
     * match), que é a que já funciona nas duas pontas. A lista só tem
     * `lastMessage`, então olha as três origens possíveis do marcador:
     *
     *  - as flags do documento de chat (`compliment` / `recadinho`), que é o
     *    que o servidor grava quando o envio leva `&compliment=true`;
     *  - `pictureId`, a foto elogiada — vem como ObjectId (`{$oid}`) ou string;
     *  - `match === false`, o elogio ainda não correspondido.
     *
     * Por que existe: a condição estava escrita à mão em cada template e as
     * duas versões divergiram — o Veggly não checava as flags. No Elogio em
     * ÁUDIO o corpo da mensagem é só `{msgType, filename, duration, fileId}`,
     * sem marcador nenhum: o `&compliment=true` viaja como query param e vira
     * flag no documento. Para quem ENVIOU, essa flag costuma ser o único
     * marcador presente — daí o ícone não aparecer só desse lado.
     */
    isCompliment(soul: any): boolean {
        if (soul?.match === false) {
            return true;
        }

        // Truthy, mas sem cair nos "falsos textuais" que o backend às vezes
        // manda ('false' e '0' são strings truthy em JS).
        const flag = (v: any) =>
            v != null && v !== false && v !== 'false' && v !== 0 && v !== '0' && v !== '';

        if (flag(soul?.compliment) || flag(soul?.recadinho)) {
            return true;
        }

        const msg = soul?.lastMessage;
        if (flag(msg?.compliment) || flag(msg?.recadinho)) {
            return true;
        }

        const pictureId = msg?.pictureId?.$oid ?? msg?.pictureId;
        return pictureId != null && pictureId !== '';
    }


}